import { createBrowserRouter } from "react-router-dom";
import AboutMe from "../components/AboutMe/AboutMe";
import AllProjects from "../components/AllProjects/AllProjects";
import Blog from "../components/Blog/Blog";
import ContactMe from "../components/ContactMe/ContactMe";
import Home from "../components/Home/Home/Home";
import Main from "../components/Main/Main";
import MyIntro from "../components/MyIntro/MyIntro";
import AbroadPortalsDetails from "../components/ProjectDetailsPage/AbroadPortalsDetails/AbroadPortalsDetails";
import BestBikeDetails from "../components/ProjectDetailsPage/BestBikeDetails/BestBikeDetails";
import CalculatorDetails from "../components/ProjectDetailsPage/CalculatorDetails/CalculatorDetails";
import CreativeCapturesDetails from "../components/ProjectDetailsPage/CreativeCapturesDetails/CreativeCapturesDetails";
import CricketTournament from "../components/ProjectDetailsPage/CricketTournament/CricketTournament";
import DailyTasksDetails from "../components/ProjectDetailsPage/DailyTasksDetails/DailyTasksDetails";
import FloodDonation from "../components/ProjectDetailsPage/FloodDonation/FloodDonation";
import LearnerAcademyDetails from "../components/ProjectDetailsPage/LearnerAcademyDetails/LearnerAcademyDetails";
import LearnerHomeDetails from "../components/ProjectDetailsPage/LearnerHomeDetails/LearnerHomeDetails";
import NewsExpress from "../components/ProjectDetailsPage/NewsExpress/NewsExpress";
import PandaCommerceDetails from "../components/ProjectDetailsPage/PandaCommerceDetails/PandaCommerceDetails";
import PhoneFinderDetails from "../components/ProjectDetailsPage/PhoneFinderDetails/PhoneFinderDetails";
import QuizManiaDetails from "../components/ProjectDetailsPage/QuizManiaDetails/QuizManiaDetails";
import WeddingBellDetails from "../components/ProjectDetailsPage/WeddingBellDetails/WeddingBellDetails";
import WorldCupDetails from "../components/ProjectDetailsPage/WorldCupDetails/WorldCupDetails";
import Projects from "../components/Projects/Projects";
import Skills2 from "../components/Skills/Skills2";
import JobHunterDetails from "../components/ProjectDetailsPage/JobHunterDetails/JobHunterDetails";
import JobNexusDetails from "../components/ProjectDetailsPage/JobNexusDetails/JobNexusDetails";
import DoctorsPortalDetails from "../components/ProjectDetailsPage/DoctotsPortalDetails/DoctotsPortalDetails";
import ErrorPage from "../components/ErrorPage/ErrorPage";
import AllBlogsPage from "../components/Blog/AllBlogsPage";
import Blog1Details from "../components/Blog/Blog1Details";
import Blog2Details from "../components/Blog/Blog2Details";
import Blog3Details from "../components/Blog/Blog3Details";
import Blog4Details from "../components/Blog/Blog4Details";
import Blog5Details from "../components/Blog/Blog5Details";
import Blog6Details from "../components/Blog/Blog6Details";
import Blog7Details from "../components/Blog/Blog7Details";
import StudyBlogsDetails from "../components/ProjectDetailsPage/StudyBlogsDetails/StudyBlogsDetails";












const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        errorElement: <ErrorPage></ErrorPage>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },

            {
                path: '/abroadPortalsDetails',
                element: <AbroadPortalsDetails></AbroadPortalsDetails>
            },

            {
                path: '/doctorsPortalDetails',
                element: <DoctorsPortalDetails></DoctorsPortalDetails>
            },

            {
                path: '/jobHunterDetails',
                element: <JobHunterDetails></JobHunterDetails>
            },

            {
                path: '/studyBlogsDetails',
                element: <StudyBlogsDetails></StudyBlogsDetails>
            },

            {
                path: '/jobNexusDetails',
                element: <JobNexusDetails></JobNexusDetails>
            },

            {
                path: '/bestBikeDetails',
                element: <BestBikeDetails></BestBikeDetails>
            },

            {
                path: '/creativeCapturesDetails',
                element: <CreativeCapturesDetails></CreativeCapturesDetails>
            },

            {
                path: '/learnerAcademyDetails',
                element: <LearnerAcademyDetails></LearnerAcademyDetails>
            },

            {
                path: '/quizManiaDetails',
                element: <QuizManiaDetails></QuizManiaDetails>
            },

            {
                path: '/worldCupDetails',
                element: <WorldCupDetails></WorldCupDetails>
            },

            {
                path: '/floodDonationDetails',
                element: <FloodDonation></FloodDonation>
            },

            {
                path: '/learnerHomeDetails',
                element: <LearnerHomeDetails></LearnerHomeDetails>
            },

            {
                path: '/weddingBellDetails',
                element: <WeddingBellDetails></WeddingBellDetails>
            },

            {
                path: '/pandaMartDetails',
                element: <PandaCommerceDetails></PandaCommerceDetails>
            },

            {
                path: '/selectBestFiveDetails',
                element: <CricketTournament></CricketTournament>
            },

            {
                path: '/calculatorDetails',
                element: <CalculatorDetails></CalculatorDetails>
            },

            {
                path: '/newsExpressDetails',
                element: <NewsExpress></NewsExpress>
            },

            {
                path: '/phoneFinderDetails',
                element: <PhoneFinderDetails></PhoneFinderDetails>
            },

            {
                path: '/dailyTasksDetails',
                element: <DailyTasksDetails></DailyTasksDetails>
            },

            {
                path: '/aboutMe',
                element: <AboutMe></AboutMe>
            },

            {
                path: '/projects',
                element: <Projects></Projects>
            },

            // {
            //     path: '/projects',
            //     element: <AllProjects></AllProjects>
            // },

            {
                path: '/skills',
                element: <Skills2></Skills2>
            },

            {
                path: '/blog',
                element: <Blog></Blog>
            },

            {
                path: '/contact',
                element: <ContactMe></ContactMe>
            },

            {
                path: '/allBlogs',
                element: <AllBlogsPage></AllBlogsPage>
            },

            {
                path: '/blog1',
                element: <Blog1Details></Blog1Details>
            },

            {
                path: '/blog2',
                element: <Blog2Details></Blog2Details>
            },

            {
                path: '/blog3',
                element: <Blog3Details></Blog3Details>
            },

            {
                path: '/blog4',
                element: <Blog4Details></Blog4Details>
            },

            {
                path: '/blog5',
                element: <Blog5Details></Blog5Details>
            },

            {
                path: '/blog6',
                element: <Blog6Details></Blog6Details>
            },

            {
                path: '/blog7',
                element: <Blog7Details></Blog7Details>
            }



        ]
    }
])

export default router;